import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import toastr from 'toastr'
import { useAuthStore } from '../store/useAuthStore'
import { navigate } from 'gatsby'

axios.interceptors.response.use(undefined, (error) => {
        const { response } = error

        if (response) {
            if (response.status === 404) {
                return Promise.reject(error)
            }

            if (response.status === 403) {
                toastr.error('Action unauthorized')
                navigate('/logout')
            }

            if (response.status === 401) {
                toastr.info('Tu sesión ha expirado')
                navigate('/logout')
            }

            // Set error details in the error object
            error.status = response.status
            error.statusText = response.statusText
            error.headers = response.headers

            // Preserve API validation and payment errors instead of replacing them with
            // Axios' generic "Request failed with status code ..." message.
            const apiMessage = response.data?.message || response.data?.error
            if (apiMessage) {
                error.message = apiMessage
            }
        }

        // Return the modified error object
        return Promise.reject(error)
    }
)

export let baseURL = ''
export let APIKEY = ''

if (process.env.NODE_ENV === 'development') {
    baseURL = 'http://localhost'
    APIKEY = 'h3u3rtK46TSVjpE1'
} else if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://canvasexpress-api-810006026250.us-central1.run.app'
    APIKEY = 'h3u3rtK46TSVjpE1'
}

export class ApiHelper {
    getAuthToken() {
        return useAuthStore.getState().token
    }

    getBaseURL() { return baseURL }

    getOutgoingHeaders(): any {
        return {
            'authorization': this.getAuthToken(),
            'request-id': uuidv4(),
            'Request-Source': 'canvasexpress_ui',
            'x-api-key': APIKEY
        }
    }

    async post(url: string, data: any) {
        try {
            return axios.post(url, data, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async postWithFiles(url: string, data: any) {
        let headers = this.getOutgoingHeaders()
        headers = {
            ...headers,
            'Content-Type': 'multipart/form-data'
        }

        try {
            return axios.post(url, data, {
                baseURL,
                headers
            })
        } catch (error) {
            throw error
        }
    }

    async put(url: string, data: any) {
        try {
            return axios.put(url, data, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }

    async get(url: string, headers: any = {}) {
        try {
            return axios.get(url, {
                baseURL,
                headers: {
                    ...this.getOutgoingHeaders(),
                    ...headers
                }
            })
        } catch (error) {
            throw error
        }
    }

    async delete(url: string) {
        try {
            return axios.delete(url, {
                baseURL,
                headers: this.getOutgoingHeaders()
            })
        } catch (error) {
            throw error
        }
    }
}

export default new ApiHelper()
